/* Hyper Denim collection infinite scroll - test theme */
(function () {
  'use strict';

  var loading = false;
  var observer = null;

  function root() {
    return document.querySelector('[data-section-type="collection-template"]');
  }

  function productList(scope) {
    return (scope || document).querySelector('[data-section-type="collection-template"] .filters-adjacent.collection-listing .product-list');
  }

  function pagination(scope) {
    return (scope || document).querySelector('[data-section-type="collection-template"] .pagination-row');
  }

  function nextUrl(scope) {
    var row = pagination(scope);
    if (!row) return null;
    var next = row.querySelector('.pagination a.next');
    return next ? next.href : null;
  }

  function prepare() {
    var row = pagination(document);
    if (!row) return;
    row.classList.add('hd-infinite-pagination');
    row.setAttribute('aria-hidden', 'true');
    observe(row);
  }

  function observe(row) {
    if (observer) observer.disconnect();
    if (!row || !nextUrl(document)) return;

    observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) loadNext();
    }, { rootMargin: '1000px 0px' });
    observer.observe(row);
  }

  function loadNext() {
    if (loading) return;
    var url = nextUrl(document);
    var currentList = productList(document);
    var currentPagination = pagination(document);
    if (!url || !currentList || !currentPagination) return;

    loading = true;
    currentPagination.classList.add('is-loading');

    fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = productList(doc);
        var newPagination = pagination(doc);
        if (!newList) throw new Error('Product list not found');

        var items = Array.prototype.slice.call(newList.children);
        items.forEach(function (item) {
          item.removeAttribute('data-cc-animate');
          item.classList.remove('cc-animate-init', 'cc-animate-in');
          currentList.appendChild(item);
        });

        if (newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
          currentPagination.classList.add('hd-infinite-pagination');
          currentPagination.setAttribute('aria-hidden', 'true');
        } else {
          currentPagination.innerHTML = '';
        }

        document.dispatchEvent(new CustomEvent('hd:infinite-scroll:loaded', { detail: { url: url } }));
        if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
        observe(currentPagination);
      })
      .catch(function (error) {
        console.error('[Hyper Denim] Infinite scroll failed:', error);
        currentPagination.classList.add('hd-infinite-error');
      })
      .finally(function () {
        loading = false;
        currentPagination.classList.remove('is-loading');
      });
  }

  function init() {
    if (!root()) return;
    prepare();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  var mutationObserver = new MutationObserver(function () {
    if (!root() || loading) return;
    var row = pagination(document);
    if (row && !row.classList.contains('hd-infinite-pagination')) prepare();
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
